document.addEventListener('DOMContentLoaded', function () {
  var min = 50;
  var max = 80;
  var viewerCount = Math.floor(Math.random() * (max - min + 1)) + min;
  var viewerElement = document.getElementById('viewer-count');
  if (viewerElement) {
      viewerElement.textContent = viewerCount;
  }
});